import { Entity } from "../helpers/Entity"
import EcommerceSettingMapping from "./EcommerceSettingMapping"
import EcommerceStyleMapping from "./EcommerceStyleMapping"
import {EcommerceRulesSet} from "./EcommerceRule"

export type EcommerceConfigurationValueAttributes = {
    integrationKey: string
    externalAccountID: string
    settingMappings: []
    styleMappings: []
    rulesMapping: EcommerceRulesSet,
    customFieldsMapping: []
}

export type CreateEcommerceConfigurationDto = {
    configurationType: string
    settingMappings: []
    styleMappings: []
    rulesMapping?: EcommerceRulesSet
}

export type EcommerceConfigurationValueDto = {
    id: string,
    type: string,
    attributes: EcommerceConfigurationValueAttributes,
}

export default class EcommerceConfiguration implements Entity {
    private dto: EcommerceConfigurationValueDto

    constructor(dto: EcommerceConfigurationValueDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "ecommerce-configuration"
    }

    getId(): string {
        return this.dto.id
    }

    getIntegrationKey(): string {
        return this.dto.attributes.integrationKey
    }

    getExternalAccountID(): string {
        return this.dto.attributes.externalAccountID
    }

    getSettingMappings(): EcommerceSettingMapping[] {
        return this.dto.attributes?.settingMappings?.map(settingMapping => new EcommerceSettingMapping(settingMapping))
    }

    getStyleMappings(): EcommerceStyleMapping[] {
        return this.dto.attributes?.styleMappings?.map(styleMapping => new EcommerceStyleMapping(styleMapping))
    }

    getEcommerceSettingMappingByType(settingType: string): EcommerceSettingMapping {
        const specifiedSetting = new EcommerceSettingMapping(Object())
        if (this) {
            const settingMappings = this.getSettingMappings()
            for (const setting of settingMappings) {
                if (setting.getType().includes(settingType)) {
                    return setting
                }
            }
        }
        return specifiedSetting
    }

    getEcommerceStyleMappingByType(styleType: string): EcommerceStyleMapping {
        const specifiedStyle = new EcommerceStyleMapping(Object())
        if (this) {
            const styleMappings = this.getStyleMappings()
            for (const style of styleMappings) {
                if (style.getType().includes(styleType)) {
                    return style
                }
            }
        }
        return specifiedStyle
    }

    getRulesMapping(): EcommerceRulesSet {
        return this.dto.attributes?.rulesMapping
    }

    getCustomFieldsMapping(): [] {
        return this.dto.attributes?.customFieldsMapping
    }

}



// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceConfigurationValues.ts